{
  "Open support, new reply": "Abrir o chat de suporte, nova resposta",
  "Open support": "Abrir o chat de suporte",
  "Attachment": "Anexo",
  "Fin · previous AI assistant": "Fin · assistente de IA anterior",
  "EventLive support team": "Equipe de suporte do EventLive",
  "{name} · EventLive support": "{name} · Suporte do EventLive",
  "EventLive AI assistant": "Assistente de IA do EventLive",
  "Could not restore your previous conversation. You can retry by reopening the app.": "Não foi possível recuperar sua conversa anterior. Para tentar de novo, abra o app novamente.",
  "Please choose a smaller image.": "Escolha uma imagem menor.",
  "Please choose a JPEG or PNG image.": "Escolha uma imagem JPEG ou PNG.",
  "Open {name}": "Abrir {name}",
  "We’re here to help": "Estamos aqui para ajudar",
  "Team review requested · AI can still help": "A equipe foi avisada · A IA pode continuar ajudando",
  "Collapse chat": "Recolher chat",
  "Expand chat": "Expandir chat",
  "Close support": "Fechar o chat de suporte",
  "Current conversation": "Conversa atual",
  "Hi! Ask me anything about EventLive: pricing, planning your livestream, or watching an event.": "Olá! Pergunte o que quiser sobre o EventLive: preços, como planejar sua transmissão ao vivo ou como assistir a um evento.",
  "Have an account? Sign in for help with your events": "Tem uma conta? Entre para receber ajuda com seus eventos",
  "Ask anything about broadcasting, your events or pricing. I can use your account details and the screen you’re on to help.": "Pergunte o que quiser sobre transmissões, seus eventos ou preços. Para ajudar, posso usar os dados da sua conta e a tela em que você está.",
  "Retry message": "Tentar enviar de novo",
  "Remove photo": "Remover foto",
  "Support message": "Mensagem para o suporte",
  "Tell us what you’re trying to do…": "Conte o que você está tentando fazer…",
  "Attach": "Anexar",
  "Could not open your photos.": "Não foi possível abrir suas fotos.",
  "Send": "Enviar",
  "Close support backdrop": "Fechar o chat de suporte (fundo)",
  "AI assistant is typing": "O assistente de IA está digitando",
  "AI assistant": "Assistente de IA",
  "Please sign in to contact support.": "Entre na sua conta para falar com o suporte.",
  "Could not reach support. Check your internet connection and try again.": "Não foi possível conectar ao suporte. Verifique sua conexão com a internet e tente novamente.",
  "Support is temporarily unavailable. Please try again.": "O suporte está temporariamente indisponível. Tente novamente.",
  "Could not send your message.": "Não foi possível enviar sua mensagem.",
  "No message sent": "Nenhuma mensagem enviada",
  "Demo delivery: screenshot included · {platform}": "Envio de teste: com captura de tela · {platform}",
  "Demo delivery: no screenshot · {platform}": "Envio de teste: sem captura de tela · {platform}",
  "EventLive · Widget test": "EventLive · Teste do widget",
  "Synthetic account and replies. No customer data or live API calls.": "Conta e respostas fictícias. Sem dados de clientes nem chamadas reais à API.",
  "Your events": "Seus eventos",
  "Family celebration": "Comemoração em família",
  "Published · Recording ready": "Publicado · Gravação pronta",
  "Demo delivery status": "Status do envio de teste",
  "{brand} support team": "Equipe de suporte do {brand}",
  "You’re chatting with the {brand} support team": "Você está conversando com a equipe de suporte do {brand}",
  "You’re talking with the {brand} AI assistant": "Você está falando com o assistente de IA do {brand}",
  "The {brand} team is answering here. If you step away, they’ll also reply by email.": "A equipe do {brand} está respondendo aqui. Se você sair, ela também vai responder por e-mail.",
  "Hi! Ask me anything about YouthStream: plans and pricing, streaming your team’s games, or watching a game.": "Olá! Pergunte o que quiser sobre o YouthStream: planos e preços, como transmitir os jogos do seu time ou como assistir a um jogo.",
  "Using the app? For help with your account, open Support Chat in YouthStream’s Profile.": "Está usando o app? Para receber ajuda com sua conta, abra o Chat de suporte no Perfil do YouthStream."
}
